module.exports = __webpack_public_path__ + "static/media/mastercard.6c261aee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cardicons/mastercard.png
// module id = 1028
// module chunks = 0